import { handleJsonResponse, getXsrfToken } from "./api";
import { getUser } from "../auth";
import config from "../config";

export async function getAdminConfiguration() {
  try
  {
    const user = getUser();
    const token = user?.access_token;
    
    const response = await fetch(`${config.API_URL}/configurations/global`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    if( response.status === 404){
      return {config: null, message: "No Admin Configuration Available."};
    }
    else
    {
      return await handleJsonResponse(response);
    }
    

  }
  catch (error) {
    throw error;
  }
}

export async function putAdminConfiguration(data) {
  try
  {
    const user = getUser();
    const token = user?.access_token;

    const response = await fetch(`${config.API_URL}/configurations/global`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-XSRF-TOKEN': getXsrfToken()
        },
        body: JSON.stringify(data)
    });
    return await handleJsonResponse(response);
  }
  catch (error) {
    throw error;
  }
}